module.exports = __webpack_public_path__ + "img/logo.6124fda1.svg";